import { asyncUpdateUser, partialUpdateUser, autocompleteMaps } from '@goldcast/api/backend';
import { backendApiClient } from './apiClient';

export function updateUserProfile({ userId, params, isAsync = true }) {
  if (params.linkedin_url) {
    try {
      const validationString = 'linkedin.com/in/';
      const profileLink = params.linkedin_url.substr(
        params.linkedin_url.indexOf(validationString) + validationString.length
      );
      params.linkedin_url = `https://www.linkedin.com/in/${profileLink}`;
    } catch (e) {
      delete params.linkedin_url;
    }
  }

  if (isAsync) {
    return asyncUpdateUser({ id: userId, body: params }).then(data => ({
      statusCode: 200,
      statusText: 'OK',
      data
    }));
  } else {
    return partialUpdateUser({ id: userId, body: params }).then(data => ({
      statusCode: 200,
      statusText: 'OK',
      data
    }));
  }
}

export function getCurrentUser() {
  return backendApiClient.get(`core/user/me`);
}

export function getCities(placeQuery) {
  if (!placeQuery) {
    return [];
  }

  return autocompleteMaps({
    queryParams: {
      search: placeQuery
    }
  })
    .then(response => {
      return response?.results || [];
    })
    .catch(() => {
      return [];
    });
}
